import './index.scss';
import './assets/rating_star.svg';
